export const environment = {
  production: false,
  firebase: {
    apiKey: 'AIzaSyDXyrsG4IA1DIdg20Wq92mJvWFNyfOoa68',
    authDomain: 'chat-38685.firebaseapp.com',
    databaseURL: 'https://chat-38685.firebaseio.com',
    projectId: 'chat-38685',
    storageBucket: 'chat-38685.appspot.com',
    messagingSenderId: '670688369861'
  }
};



// WEBPACK FOOTER //
// /Users/azerty/friendlychat-web/cloud-functions-angular-start/src/environments/environment.ts